import * as React from 'react';
import { IGeneralDentalReferral } from '../../../../models/IGeneralDentalReferral';
import { TextInput, HiddenInput } from 'soprasteria-ui-library';
import { formatAddress } from '../../../../helpers/AddressHelper';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";

interface IGeneralDentalReferralRecipientInformation {
    generalDentalReferral: IGeneralDentalReferral;
}

export const GeneralDentalReferralRecipientInformation: React.FunctionComponent<IGeneralDentalReferralRecipientInformation> = ({ generalDentalReferral }) => {

    return (
        <>
            <div className="row readonly-less-margin">
                <h5 className="col-12">Information om mottagaren</h5>
                <HiddenInput name="recipientCareProviderId" value={generalDentalReferral.recipientCareProvider.careProviderId.toString()} />
                <div className="col-6">
                    <TextInput name="readonlyRecipientOrganisationInformation" label="Vårdgivare" defaultValue={generalDentalReferral.recipientCareProvider.displayOrganisationInformation} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="readonlyRecipientEmail" label="E-post" defaultValue={generalDentalReferral.recipientCareProvider.address?.emailAddress ?? "Saknas"} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="readonlyRecipientCareProvider" label="Mottagning" defaultValue={generalDentalReferral.recipientCareProvider.displayCareProviderName} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="readonlyRecipientPhoneNumber" label="Telefonnummer" defaultValue={generalDentalReferral.recipientCareProvider.address?.phoneNumber} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="readonlyRecipientAddress" label="Mottagningens adress" defaultValue={formatAddress(generalDentalReferral.recipientCareProvider.address)} inlineLabel readonly />
                </div>                
                <div className="col-6">
                    <TextInput name="readonlyRecipientAlternativePhoneNumber" label="Alt telefonnummer" defaultValue={generalDentalReferral.recipientCareProvider.address?.alternativePhoneNumber ?? "Saknas"} inlineLabel readonly />
                </div>
                
            </div>
            <hr />
        </>
    )
}